import {useAuth0} from '@auth0/auth0-react';
import {FormControlLabel, Switch, Typography} from '@mui/material';
import {type Plan} from 'client';
import {EMPTY_ID, useGetPlans} from 'hooks/swr';
import {useTranslation} from 'react-i18next';
import {PLANS_FILTER_STORE_KEY} from 'appConstants';
import {create} from 'zustand';
import {persist} from 'zustand/middleware';

export const MyPlansSwitch = ({userPlans}: {userPlans?: Plan[]}) => {
  const {t} = useTranslation('common');
  const {filter, setFilter} = usePlansFilterState();
  if (!userPlans) {
    return null;
  }
  return (
    <FormControlLabel
      label={
        <Typography variant="body2" color="secondary" sx={{userSelect: 'none'}}>
          {t('myPlans')}
        </Typography>
      }
      control={
        <Switch
          sx={{m: 1}}
          size="small"
          checked={filter.myPlans}
          onChange={({target: {checked}}) => {
            setFilter({...filter, myPlans: checked});
          }}
        />
      }
    />
  );
};

export const useGetUserPlans = () => {
  const {filter} = usePlansFilterState();
  const dataPlans = useGetPlans({resourceId: EMPTY_ID});
  const {user} = useAuth0();
  const userPlans = user && dataPlans.data?.filter((plan) => plan.createdBy === user.sub);
  const displayPlans = filter.myPlans && userPlans && userPlans?.length > 0 ? userPlans : dataPlans.data;
  const plans = displayPlans
    ? [...displayPlans].sort((a, b) => {
        if (a.updatedAt && b.updatedAt) {
          return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
        } else {
          return 0;
        }
      })
    : undefined;
  return {plans, userPlans};
};

interface PlansFilterState {
  myPlans: boolean;
}

export const usePlansFilterState = create(
  persist<{
    filter: PlansFilterState;
    setFilter: (filter: PlansFilterState) => void;
  }>(
    (set) => ({
      filter: {
        myPlans: true,
      },
      setFilter: (filter) => {
        set({filter});
      },
    }),
    {
      name: PLANS_FILTER_STORE_KEY,
    },
  ),
);
